import { ModalActor } from 'xstate/actors/ModalActor';
import { StateValue } from 'xstate/machines/ModalMachine';
import { useSelector } from '@xstate/react';

interface UseModalResult {
  modalState: ReturnType<typeof ModalActor.getSnapshot>;
  isClosed: boolean;
  isOpen: boolean;
  view: any;
  payload: any;
}

/**
 * This hook wraps the Modal Service with a few convenience helpers. Destructuring allows to
 * keep the consumer's logic minimal.
 */
export const useModal = (): UseModalResult => {
  const modalState = useSelector(ModalActor, (snapshot) => snapshot);

  // State Helpers
  const isClosed = modalState.matches(StateValue.Closed);
  const isOpen = modalState.matches(StateValue.Open);

  // Context Helpers
  const view = modalState.context.view;
  const payload = modalState.context.payload;

  return {
    modalState,
    isClosed,
    isOpen,
    view,
    payload,
  };
};
